import Cookies from "js-cookie"
import InfoBanner from "../Utils/InfoBanner"
import Instagram from "../Utils/Instagram"
import OurPick from "../Utils/OurPick"
import ShoppingBanner from "../Utils/ShoppingBanner"
import ShoppingCategory from "../Utils/ShoppingCategory"
import VideoBanner from "../Utils/VideoBanner"
import { BrandDetailItemProps } from "./constants"
import { NextSeo } from "next-seo"


const MOOIMOM = (props: BrandDetailItemProps) => {
  const viewport = Cookies.get('viewport');

  return (
    <>
      <NextSeo
        title=''
        defaultTitle='Mooimom | Mom & Baby Store | Accompany Mom&apos;s Journey'
        description="MOOIMOM provides the best for mothers and baby. As a mom and baby store, we are committed to offer high quality baby and mom products."
        canonical={process.env.NEXT_PUBLIC_HOSTNAME + "/brand/mooimom"}
        openGraph={{
          images: [{
            url: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-mooimom-middle.png",
            width: 577,
            height: 214,
            alt: 'MOOIMOM logo image',
          }]
        }}
      />
      {props.main_banner.length > 0 && props.main_banner[0].video !== null && (
        <VideoBanner
          video={props.main_banner[0].video}
          title={props.main_banner[0].text}
          brand_image={viewport === "desktop" ? process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-mooimom-white-right.png" : process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-mooimom-white-left.png"}
          brand_image_alt="MOOIMOM logo"
          brand_image_width={500}
          brand_image_height={245}
          brand_image_style="max-w-[170px] md:max-w-[200px] mb-6"
          area_style="bottom-[106px] md:right-[100px]"
          style="text-right justify-end"
          mobile_style="justify-start text-left"
        />
      )}
      {props.shopping_category.length > 0 && (
        <ShoppingCategory
          banner_list={props.shopping_category}
          title="Shop by Category"
        />
      )}
      {Object.keys(props.info_banner).length > 0 && (
        <InfoBanner
          desktop_image={props.info_banner.desktop_image}
          mobile_image={props.info_banner.mobile_image}
          image_alt={props.info_banner.image_alt}
          link={props.info_banner.link}
          style={props.info_banner.style}
          text={props.info_banner.text}
          desc={props.info_banner.desc}
          button_text={props.info_banner.button_text}
          custom_text={props.info_banner.custom_text}
          bg_color="bg-[#FCFCF8]"
          text_color="text-[#2C3E2F]"
          button_bg_color="bg-[#2C3E2F]"
          button_text_color="text-white"
          mb_button_bg_color="bg-[#2C3E2F]"
          mb_button_text_color="text-white"
        />
      )}
      {props.our_picks.length > 0 && (
        <div className="container">
          <OurPick
            tittle={props.our_picks[0].tittle}
            see_all_link={props.our_picks[0].see_all_link}
            banner_list={props.our_picks[0].banner_list}
            product_list={props.our_picks[0].product_list}
            attrId={null}
            customName={null}
            expandColor={null}
            showBorder={false}
          />
        </div>
      )}
      {props.shopping_banners.length > 0 && (
        <ShoppingBanner
          banners={props.shopping_banners}
          brand_image={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/brand/logo-mooimom-white-left.png"}
          brand_image_alt="MOOIMOM logo"
          brand_image_style="mb-12"
          bg_color=""
          text_color="text-[#FCFCF8]"
          style=""
          button_bg_color="bg-[#2C3E2F]"
          button_text_color="text-white"
        />
      )}
      {props.our_picks.length > 1 && (
        <div className="container">
          <OurPick
            tittle={props.our_picks[1].tittle}
            see_all_link={props.our_picks[1].see_all_link}
            banner_list={props.our_picks[1].banner_list}
            product_list={props.our_picks[1].product_list}
            attrId={null}
            customName={null}
            expandColor={null}
            showBorder={false}
          />
        </div>
      )}
      {props.instagram.length > 0 && (
        <Instagram
          instagram={props.instagram}
          title="Find more about MOOIMOM on Instagram"
          mobile_title="Find more about<br />MOOIMOM on Instagram"
        />
      )}
    </>
  )
}

export default MOOIMOM
